import React, { useState } from "react";
import { Button, Dropdown, Menu, Icon } from "antd";

const CustomDropdown = ({
  pageNumber,
  currentValue,
  predefinedDocsCode = [],
  onChange,
}) => {
  const [selected, setSelected] = useState(currentValue || "--SELECT--");

  const handleMenuClick = (e) => {
    setSelected(e.key);
    onChange && onChange(e.key); // Notify parent
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="--SELECT--">--SELECT--</Menu.Item>
      {predefinedDocsCode.map((code) => (
        <Menu.Item key={code.toUpperCase()}>{code.toUpperCase()}</Menu.Item>
      ))}
    </Menu>
  );

  return (
<Dropdown
  overlay={menu}
  trigger={["click"]}
  placement="bottomLeft"
  getPopupContainer={(triggerNode) => triggerNode.parentNode}
>
  <Button
    style={{
      backgroundColor: "#e2e6f5",
      color: "#576ec1",
      borderRadius: "30px",
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      width: "100%",
      marginTop: 8,
    }}
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    {selected} <Icon type="down" />
  </Button>
</Dropdown>

  );
};

export default React.memo(CustomDropdown);

